export default __webpack_public_path__ + "media/zurb/img/home/insight-1-0dc1116c936358262d3cfc4145a44264.gif";